<template>
    <v-container>
        <v-chart :options="option" style="width:100%"/>
    </v-container>
</template>
<script>
export default {
    name: "SpectroscopicallyTNS",
    data() {
        return {
            type_data: [],
            type_names: [],
            type_count: [],
            confirmed: 0,
            option: {
                title: {
                    text: 'Spectroscopically classified SNe',
                    subtext: ''
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'category',
                    data: []
                },
                series: [
                    {
                        name: 'Confirmed',
                        type: 'bar',
                        data: []
                    }
                ]
            }
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData(){
            this.$tnsapi.get_sne_confirmed_stats("ALeRCE").then(response => {
                this.type_data = response.data;
            });
        },
    },
    watch: {
        type_data(newVal) {
            this.type_names = newVal.map(x => x.type).reverse();
            this.type_count = newVal.map(x => x.count).reverse();
        },
        type_names(newVal) {
            this.option.yAxis.data = newVal;
        },
        type_count(newVal) {
            this.option.series[0].data = newVal;
            this.confirmed = newVal.reduce((a, b) => a + b, 0)
        },
        confirmed(newVal) {
            let today = new Date().toISOString().split("T")[0]
            this.option.title.subtext = `${newVal} confirmed at ${today}`
        }
    }
};
</script>